// == Page info
import {Info} from '@/vuex/modules/pageInfo/Info.js'

// == Bar charts
import {AddressTypes} from '@/vuex/modules/barCharts/AddressTypes.js'
import {CollisionTypes} from '@/vuex/modules/barCharts/CollisionTypes.js'
import {DamageCosts} from '@/vuex/modules/barCharts/DamageCosts.js'
import {JunctionTypes} from '@/vuex/modules/barCharts/JunctionTypes.js'
import {LightConditions} from '@/vuex/modules/barCharts/LightConditions.js'
import {RoadConditions} from '@/vuex/modules/barCharts/RoadConditions.js'
import {Weather} from '@/vuex/modules/barCharts/Weather.js'

import {MonthlyCollisions} from '@/vuex/modules/lineCharts/MonthlyCollisions.js'

import {WhoRank} from '@/vuex/modules/tables/WhoRank.js'
import {SeverityRank} from '@/vuex/modules/tables/SeverityRank.js'

const modules = {
  pageInfo: Info,
  addressTypes: AddressTypes,
  collisionTypes: CollisionTypes,
  damageCosts: DamageCosts,
  junctionTypes: JunctionTypes,
  lightConditions: LightConditions,
  roadConditions: RoadConditions,
  weather: Weather,
  whoRank: WhoRank,
  severityRank: SeverityRank,
  monthlyCollisions: MonthlyCollisions
}

const state = {
  resultsFilters: {}
}

const mutations = {
  SET_RESULTS_FILTERS (state, filters) {
    state.resultsFilters = filters
  }
}

const actions = {
  fetchAll: function ({commit, dispatch}, params) {
    commit('SET_RESULTS_FILTERS', params.filters)
    dispatch('pageInfo/fetch', {slug: '/neighborhood/' + params.id + '/info', filters: params.filters})

    dispatch('addressTypes/fetch', {slug: '/neighborhood/' + params.id + '/address/types/', filters: params.filters})
    dispatch('collisionTypes/fetch', {slug: '/neighborhood/' + params.id + '/collision/types/', filters: params.filters})
    dispatch('damageCosts/fetch', {slug: '/neighborhood/' + params.id + '/costs/economic', filters: params.filters})
    dispatch('junctionTypes/fetch', {slug: '/neighborhood/' + params.id + '/junction/types/', filters: params.filters})
    dispatch('lightConditions/fetch', {slug: '/neighborhood/' + params.id + '/light/conditions/', filters: params.filters})
    dispatch('roadConditions/fetch', {slug: '/neighborhood/' + params.id + '/road/conditions/', filters: params.filters})
    dispatch('weather/fetch', {slug: '/neighborhood/' + params.id + '/weather', filters: params.filters})

    dispatch('whoRank/fetch', {slug: '/neighborhood/' + params.id + '/rankings/who', filters: params.filters})
    dispatch('severityRank/fetch', {slug: '/neighborhood/' + params.id + '/rankings/severity', filters: params.filters})
    dispatch('monthlyCollisions/fetch', {slug: '/neighborhood/' + params.id + '/monthlycollisions', filters: params.filters})
  },

  setFilters: function ({dispatch, rootState}) {
    let startDate = (typeof rootState.route.params.sd === 'undefined') ? '2006-01-01' : rootState.route.params.sd

    dispatch('filterDateRange/setStartDate', startDate, {root: true})
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, {root: true})
  },

  resetResults: function ({dispatch}) {
    dispatch('pageInfo/reset')
    dispatch('addressTypes/reset')
    dispatch('collisionTypes/reset')
    dispatch('monthlyCollisions/reset')
    dispatch('junctionTypes/reset')
    dispatch('lightConditions/reset')
    dispatch('roadConditions/reset')
    dispatch('weather/reset')
    dispatch('whoRank/reset')
    dispatch('severityRank/reset')
    dispatch('damageCosts/reset')
  }
}

const getters = {
  filters (state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    }
  },

  resultsFilters: state => state.resultsFilters
}

export const NeighborhoodView = {
  namespaced: true,
  modules,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/views/NeighborhoodView.js